import * as React from 'react';
export const ReactFragmentOrDiv = ({ isDiv, children, ...rest }) => isDiv ? (React.createElement("div", { ...rest }, children)) : (React.createElement(React.Fragment, null, children));
//# sourceMappingURL=ReactFragmentOrDiv.js.map